import { Viewable } from './viewable.js';

export class HtmlElementView implements Viewable {
  constructor(
    private readonly rootElement: HTMLElement,
  ) {}

  show() {
    this.rootElement.classList.remove('hidden');
  }

  hide() {
    if (this.rootElement.classList.contains('hidden')) {
      return;
    }
    this.rootElement.classList.add('hidden');
  }
}
